import { Avatar, Card, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core";
import Paginacao from "../../utils/paginacao";
import SearshDirectorTecnico from "./searchDirectorTecnico";
import RegisterAccess from "../../utils/registerAccess";
import ListaVazia from "../../utils/listaVazia";
import HeaderSession from "../../utils/headerSession";
import { RelatorioDirectoresTecnicosPdf } from "../exports/gerarelatoriopdf";
import { RelatorioDirectoresTecnicosExcel } from "../exports/gerarelatorioexcel";
import TabelaLoading from "../../load/tabelaLoading";


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#d2d6ff' }, cursor: 'pointer' }
}))

export default function DirectoresTecnicos() {
    const classes = useStyles()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState('')
    const [directorTecnicos, setDirectorTecnicos] = useState(useSelector(state => state?.directoresTecnicos?.data) ?? '')
    const [configLista, setConfigLista] = useState(useSelector(state => state?.directoresTecnicos?.config) ?? '')
    const dispatch = useDispatch();
    const [perPage, setPerPage] = useState(20)
    const [order, setOrder] = useState('ASC')
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));

    useEffect(() => {
        setLoading(true)
        api.get(`/director-tecnicos?page=${page}&perPage=${perPage}&sortBy=createdAt:${order}`)
            .then(response => {
                // console.log(response)
                setConfigLista(response.data);
                setDirectorTecnicos((prevItems) => [...prevItems, ...response.data.directorTecnicos]);
                // setFilter(response.data.directorTecnicos);

                setLoading(false)
            }).catch(err => { setLoading(false) })

        dispatch({
            type: 'directoresTecnicos',
            payload: { directoresTecnicos: directorTecnicos, config: configLista },
        }); //dispatch para por os directorTecnicos no state da aplicacao e evitar recarregar desnecessariamente

    }, [page, perPage, order]);


    return (
        <>
            <RegisterAccess page={'lista de directores técnicos registados'} />

            <HeaderSession
                title='DIRECTORES TÉCNICOS REGISTADOS'
                actions={true}
                handleExportExcel={() => RelatorioDirectoresTecnicosExcel(directorTecnicos)}
                handleExportPDF={() => RelatorioDirectoresTecnicosPdf(directorTecnicos)}
            />

            {directorTecnicos &&

                <Card style={{ padding: 20, minHeight: '20vh', }}>

                    <SearshDirectorTecnico setDirectorTecnico={setDirectorTecnicos} setPesquisaError={setErrorMessage} />

                    <Card variant="outlined">
                        <TableContainer sx={{ border: "1px black" }} component={Paper}>
                            <Table sx={{ border: "1px", borderColor: "black" }}>
                                <TableHead sx={{ backgroundColor: "#dcdede" }}>
                                    <TableRow>
                                        <TableCell><Typography noWrap> <strong>Foto</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Carteira</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Categoria</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Telefone</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                                        <TableCell><Typography noWrap> <strong>Municipio</strong></Typography></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {directorTecnicos.map((directorTecnico) => (
                                        <TableRow key={directorTecnico.dadosPessoais?._id} onClick={() => navigate(`/admin/get-director-tecnico/${directorTecnico._id}`)} className={classes.hover}>

                                            <TableCell>
                                                <Avatar src={directorTecnico.dadosPessoais?.fotoURL} />
                                            </TableCell>

                                            <TableCell>{directorTecnico.dadosPessoais?.nome}</TableCell>
                                            <TableCell>{directorTecnico.numeroCarteira}</TableCell>
                                            <TableCell>{directorTecnico?.categoria?.designacao}</TableCell>
                                            <TableCell> <Typography noWrap> {directorTecnico.dadosPessoais?.tel1}</Typography></TableCell>
                                            <TableCell> <Typography noWrap> {directorTecnico.dadosPessoais?.provincia}</Typography></TableCell>
                                            <TableCell> <Typography noWrap> {directorTecnico.dadosPessoais?.municipio}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            {errorMessage && <ListaVazia text={errorMessage} />}

                        </TableContainer>
                    </Card>

                    <Paginacao
                        configLista={configLista}
                        lista={directorTecnicos}
                        page={page}
                        setPage={setPage}
                        setPerPage={setPerPage}
                        setOrder={setOrder}
                    // exportarExcel={exportarExcel}
                    />
                </Card>
            }

            {loading && <TabelaLoading />}
        </>
    )
}